import React from 'react';
import styled from '@emotion/styled';

const StyledInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  resize: vertical;
  font-family: 'Open Sans',sans-serif;
  font-size: 15px;
  
  :focus {
    outline: none;
  }
`;

export default StyledInput;
